<template>
  <label class="toggle-switch">
    <input
      v-model="checkedRef"
      :disabled="disabled"
      type="checkbox"
      class="input"
      :checked="isChecked"
      @change="() => emit('update:isChecked', checkedRef)"
    />
    <span class="switch" :style="`--color: ${color}`" />
  </label>
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = defineProps({
  /** The state of button */
  isChecked: {
    type: Boolean,
    required: false,
  },
  color: {
    type: String,
    required: false,
    default: "green",
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const checkedRef = ref(props.isChecked);
const emit = defineEmits(["update:isChecked"]);
</script>

<style scoped lang="scss">
label {
  margin-bottom: 0px;
}

.toggle-switch {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  .label {
    margin-right: 9px;
    color: #b7b7b7;
    letter-spacing: 1px;
  }

  /* Visually hide the checkbox input */
  .input {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .switch {
    --switch-container-width: 38.5px;
    --switch-size: calc(var(--switch-container-width) / 1.75);
    --light-gray: #ccc;
    --gray: #cbd5e0;
    --green: #01893d;
    display: flex;
    align-items: center;
    position: relative;
    height: var(--switch-size);
    width: var(--switch-container-width);
    border-radius: 70px;
    background-color: #fff;
    flex-shrink: 0;
    transition: background-color 0.25s ease-in-out;
    border: 0.786px solid var(--rule, #ccc);
    &::before {
      content: "";
      position: absolute;
      left: 1px;
      height: calc(var(--switch-size) - 4px);
      width: calc(var(--switch-size) - 4px);
      border-radius: 9999px;
      background-color: var(--light-gray);
      transition: transform 0.375s ease-in-out;
    }
  }

  .input:checked {
    + .switch {
      background-color: var(--color, green);
      border-color: var(--color, green);
      &::before {
        border-color: var(--color, green);
        /* Move the inner circle to the right */
        transform: translateX(
          calc(var(--switch-container-width) - var(--switch-size))
        );
        background-color: white;
      }
    }
    ~ .label {
      color: #211f58;
    }
  }

  .input:focus + .switch::before {
    border-color: var(--gray);
  }

  .input:disabled + .switch {
    background-color: var(--gray);
  }
}
</style>
